export const regiaoSintomasList = [
  { value: "", label: "Selecione" },
  { value: "1", label: "Membro superior proximal direito (elevação do braço)" },
  {
    value: "2",
    label: "Membro superior proximal esquerdo (elevação do braço)",
  },
  { value: "3", label: "Membro superior distal direito (fraqueza mão)" },
  { value: "4", label: "Membro superior distal esquerdo (fraqueza mão)" },
  { value: "5", label: "Membro inferior direito (perna)" },
  { value: "6", label: "Membro inferior esquerdo (perna)" },
  { value: "7", label: "Falta de ar" },
  { value: "8", label: "Dificuldades para engolir e engasgos" },
  { value: "9", label: "Dificuldade para articular palavras e fonação" },
  { value: "10", label: "Não é possível determinar" },
];

export const sinaisSintomasList = [
  { value: "11", label: "Atividade física intensa" },
  { value: "12", label: "Perda de sensibilidade" },
  {
    value: "13",
    label: "Dificuldades na escrita",
  },
  { value: "14", label: "Perda de peso" },
  { value: "15", label: "Sono (sonolência diurna)" },
  { value: "16", label: "Cãibras" },
  { value: "17", label: "Disfonia" },
  { value: "18", label: "Edemas" },
  { value: "19", label: "Atrofia" },
  { value: "20", label: "Dor" },
  { value: "21", label: "Sialorréia" },
  { value: "22", label: "Ortopnéia" },
  { value: "23", label: "Dispneia" },
  { value: "24", label: "Cefaléia matinal" },
  { value: "25", label: "Humor" },
  { value: "26", label: "Força para tossir" },
  { value: "27", label: "Choro ou riso incontrolado" },
  { value: "28", label: "Disartria" },
  { value: "29", label: "Alterações na marcha" },
  { value: "30", label: "Disfagia" },
  { value: "31", label: "Alteração dos esfincteres urinário e fecal" },
  { value: "32", label: "Fraqueza" },
  { value: "33", label: "Fasciculações" },
];
export const antecedentepessoaisList = [
  { value: "35", label: "Choque elétrico" },
  { value: "36", label: "Serviço militar" },
  {
    value: "39",
    label: "Traumatismo crânio encefálico",
  },
  { value: "37", label: "Tabagismo" },
  { value: "38", label: "Etilismo" },
  { value: "40", label: "Contato com inseticidas" },
  { value: "41", label: "Contato com metais pesados" },
];

export const comorbidadesList = [
  { value: "42", label: "Hipertensão arterial sistêmica" },
  { value: "44", label: "Cardiopatia esquêmica" },
  { value: "48", label: "Dislipidemia" },
  { value: "49", label: "Demência" },
  { value: "45", label: "Doença psiquiátrica" },
  { value: "47", label: "Doenças autoimunes" },
];

export const parentescoList = [
  { value: "52", label: "Pai" },
  { value: "53", label: "Mãe" },
  { value: "54", label: "Filho" },
  { value: "55", label: "Irmão" },
  { value: "34", label: "Outros" },
];
